import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=b85ab85c&scoped=true&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ab85c",
  null
  
)

export default component.exports